import {
  COMPLETE_BULK_UPLOAD_FILES_SUCCESS,
  DELETE_REPORT_SUCCESS,
  DOWNLOAD_REPORT_REQUEST,
  DOWNLOAD_REPORT_SUCCESS,
  FILE_PARTS_UPLOAD_FAILURE,
  FILE_PARTS_UPLOAD_REQUEST,
  FILE_PARTS_UPLOAD_SUCCESS,
  GET_DOWNLOAD_REPORT_URL_REQUEST,
  GET_DOWNLOAD_REPORT_URL_SUCCESS,
  GET_REPORT_DETAILS_SUCCESS,
  GET_TERM_REPORT_CONFIGS_FAILURE,
  GET_TERM_REPORT_CONFIGS_REQUEST,
  GET_TERM_REPORT_CONFIGS_SUCCESS,
  PREVIEW_ENABLED,
  RESET_BULK_FILES_PART_STATE,
  RESET_GET_REPORT_DETAILS,
  RESET_IS_TRIGGER_SEARCH_REPORT,
  RESET_REPORT_LIST,
  SEARCH_REPORTS_REQUEST,
  SEARCH_REPORTS_SUCCESS,
  SELECT_LP,
  SET_CURRENT_FOLDER_PATH,
  SET_CURRENT_PAGE,
  SET_FILTER_SHEET_OPEN,
  SET_FILTERS,
  SET_REPORT_SELECTION,
  SET_SEARCH_REPORTS_PAGE_SIZE,
  SET_SORT_CRITERIA,
  START_GET_REPORT_DETAILS_POLLING_REQUEST,
  STOP_GET_REPORT_DETAILS_POLLING_REQUEST,
  UPLOAD_FILE_FOLDER_SUCCESS,
} from '../../actions/types';
import { DEFAULT_REPORTS_LIST_PAGE_SIZE } from '../../constants';
import { UPLOAD_STATUS } from '../../constants/upload';
import { DEFAULT_SORT_CRITERIA } from '../../constants/search';
import { DOWNLOAD_TYPE } from '../../constants/download';
import { ReportCenterStateType } from '../../actions/typeDefs';

export const initialState: ReportCenterStateType = {
  reportsList: [],
  reportsListTotalRecords: 0,
  searchReportsPageSize: DEFAULT_REPORTS_LIST_PAGE_SIZE,
  termReportConfigs: null,
  getTermReportConfigsError: false,
  downloadedReport: null,
  lpSelected: '',
  bulkFilesPartsUpload: {},
  isTriggerSearchReport: false,
  currentFolderPath: '',
  currentPage: 1,
  selectedReports: [],
  sortCriteria: DEFAULT_SORT_CRITERIA,
  isPreviewEnabled: false,
  downloadReportPresignedURL: null,
  reportDetails: null,
  filterSheetOpen: false,
  filters: {},
  isGetReportDetailsPolling: false,
};

export function reportsCenterReducer(
  state = initialState,
  { type, payload }: { type: string; payload: any }
) {
  switch (type) {
    case SEARCH_REPORTS_REQUEST: {
      return {
        ...state,
        reportsListTotalRecords: 0,
      };
    }
    case SEARCH_REPORTS_SUCCESS: {
      return {
        ...state,
        reportsList: payload.reportList,
        reportsListTotalRecords: payload.totalRecords,
      };
    }
    case GET_TERM_REPORT_CONFIGS_REQUEST: {
      return {
        ...state,
        getTermReportConfigsError: false,
      };
    }

    case GET_TERM_REPORT_CONFIGS_SUCCESS: {
      return {
        ...state,
        termReportConfigs: payload,
      };
    }

    case GET_TERM_REPORT_CONFIGS_FAILURE: {
      return {
        ...state,
        getTermReportConfigsError: true,
      };
    }

    case DOWNLOAD_REPORT_SUCCESS: {
      if (
        payload?.downloadType === DOWNLOAD_TYPE.SUPPORTING_DOCUMENTS &&
        Object.values(payload?.supportingDocumentUrls ?? {})?.length
      ) {
        Object.values(payload?.supportingDocumentUrls ?? {})?.forEach(
          (downloadUrl, index) => {
            if (payload?.supportingDocumentKey) {
              if (
                Object.keys(payload?.supportingDocumentUrls ?? {})?.[
                  index
                ]?.endsWith(payload?.supportingDocumentKey)
              ) {
                window.open(downloadUrl, '_blank');
              }
            } else {
              window.open(downloadUrl, '_blank');
            }
          }
        );
      } else if (
        payload?.downloadType === DOWNLOAD_TYPE.REPORT &&
        payload?.downloadUrl
      ) {
        window.open(payload?.downloadUrl, '_blank');
      }
      return {
        ...state,
        downloadedReport: payload,
      };
    }

    case SELECT_LP: {
      return {
        ...state,
        lpSelected: payload,
        currentPage: 1,
        currentFolderPath: '',
        selectedReports: [],
      };
    }

    case RESET_REPORT_LIST: {
      return {
        ...state,
        reportsList: [],
        reportsListTotalRecords: 0,
      };
    }

    case SET_CURRENT_FOLDER_PATH: {
      return {
        ...state,
        currentFolderPath: payload,
        currentPage: 1,
        selectedReports: [],
      };
    }

    case SET_CURRENT_PAGE: {
      return {
        ...state,
        currentPage: payload,
        selectedReports: [],
      };
    }

    case SET_SEARCH_REPORTS_PAGE_SIZE: {
      return {
        ...state,
        searchReportsPageSize: payload,
        currentPage: 1,
      };
    }

    case FILE_PARTS_UPLOAD_REQUEST: {
      return {
        ...state,
        bulkFilesPartsUpload: {
          ...state.bulkFilesPartsUpload,
          [payload.key]: {
            status: UPLOAD_STATUS.IN_PROGRESS,
            uploadId: payload.uploadId,
            reportId: payload.reportId,
            supportingDocumentInfo: payload.supportingDocumentInfo,
            partPresignedURLs: payload.partPresignedURLs,
            key: payload.key,
            logisticsPartyId: payload.logisticsPartyId,
            reportType: payload.reportType,
            term: payload.term,
          },
        },
      };
    }

    case FILE_PARTS_UPLOAD_SUCCESS: {
      return {
        ...state,
        bulkFilesPartsUpload: {
          ...state.bulkFilesPartsUpload,
          [payload.key]: {
            ...(state.bulkFilesPartsUpload[payload.key] || {}),
            status: UPLOAD_STATUS.SUCCESS,
            eTags: payload.eTags,
          },
        },
      };
    }

    case RESET_IS_TRIGGER_SEARCH_REPORT: {
      return {
        ...state,
        isTriggerSearchReport: false,
      };
    }

    case FILE_PARTS_UPLOAD_FAILURE: {
      return {
        ...state,
        bulkFilesPartsUpload: {
          ...state.bulkFilesPartsUpload,
          [payload.key]: {
            ...(state.bulkFilesPartsUpload[payload.key] || {}),
            status: UPLOAD_STATUS.FAILURE,
          },
        },
      };
    }

    case COMPLETE_BULK_UPLOAD_FILES_SUCCESS: {
      return {
        ...state,
        isTriggerSearchReport: true,
        bulkFilesPartsUpload: {},
        selectedReports: [],
      };
    }

    case RESET_BULK_FILES_PART_STATE: {
      return {
        ...state,
        bulkFilesPartsUpload: {},
      };
    }
    case DELETE_REPORT_SUCCESS: {
      return {
        ...state,
        isTriggerSearchReport: true,
        selectedReports: [],
      };
    }

    case UPLOAD_FILE_FOLDER_SUCCESS: {
      return {
        ...state,
        isTriggerSearchReport: true,
        selectedReports: [],
      };
    }

    case SET_REPORT_SELECTION: {
      return {
        ...state,
        selectedReports: payload,
      };
    }

    case SET_SORT_CRITERIA: {
      return {
        ...state,
        sortCriteria: payload,
      };
    }
    case PREVIEW_ENABLED: {
      return {
        ...state,
        isPreviewEnabled: payload,
      };
    }
    case GET_DOWNLOAD_REPORT_URL_REQUEST: {
      return {
        ...state,
        downloadReportPresignedURL: null,
      };
    }
    case GET_DOWNLOAD_REPORT_URL_SUCCESS: {
      return {
        ...state,
        downloadReportPresignedURL: payload,
      };
    }

    case START_GET_REPORT_DETAILS_POLLING_REQUEST: {
      return {
        ...state,
        isGetReportDetailsPolling: true,
      };
    }

    case STOP_GET_REPORT_DETAILS_POLLING_REQUEST: {
      return {
        ...state,
        isGetReportDetailsPolling: false,
      };
    }

    case GET_REPORT_DETAILS_SUCCESS: {
      return {
        ...state,
        reportDetails: payload?.reportList?.length
          ? payload.reportList[0]
          : null,
      };
    }

    case RESET_GET_REPORT_DETAILS: {
      return {
        ...state,
        reportDetails: null,
      };
    }

    case SET_FILTER_SHEET_OPEN: {
      return {
        ...state,
        filterSheetOpen: payload,
      };
    }

    case SET_FILTERS: {
      return {
        ...state,
        filters: payload,
      };
    }
    default: {
      return state;
    }
  }
}
